import { css } from '@dna/core'
import * as React from 'react'

import { BoxProps, ScopedCSSRules } from '@dna/react-types'

import { Box } from '../box'

function getSizeStyle(scale: number) {
  return {
    flex: `0 0 ${scale * 100}%`,
  }
}

let widths: any = {
  '1/2': getSizeStyle(1 / 2),
  '1/3': getSizeStyle(1 / 3),
  '2/3': getSizeStyle(2 / 3),
  '1/4': getSizeStyle(1 / 4),
  '3/4': getSizeStyle(3 / 4),
  '1/5': getSizeStyle(1 / 5),
  '2/5': getSizeStyle(2 / 5),
  '3/5': getSizeStyle(3 / 5),
  '4/5': getSizeStyle(4 / 5),
}

type ColumnWidth =
  | 'content'
  | '1/2'
  | '1/3'
  | '2/3'
  | '1/4'
  | '3/4'
  | '1/5'
  | '2/5'
  | '3/5'
  | '4/5'

function columnStyles({ width }: { width?: ColumnWidth }) {
  if (width === 'content') {
    return {
      flexShrink: 0,
    }
  } else if (width) {
    return {
      ...widths[width],
    }
  } else {
    return {
      width: '100%',
    }
  }
}

interface ColumnProps extends BoxProps {
  width?: ColumnWidth
}

/**
 * If you need to lay out content horizontally, use ‘Columns’ and ‘Column’ components.
 *
 * @name
 * Column
 *
 * @see
 * https://dna.telstrahealth.com/components/column
 *
 * @example
 * <Columns>
 *   <Column width="1/2">
 *     <Text>Column one</Text>
 *   </Column>
 *   <Column>
 *     <Text>Fluid width</Text>
 *   </Column>
 * </Columns>
 */
export function Column(props: ColumnProps) {
  let { children, width, css: styleProps = {}, ...otherProps } = props
  let styles = columnStyles({ width })

  return (
    <Box
      {...otherProps}
      UNSAFE_className={css(styles as ScopedCSSRules)}
      css={{ ...columnStyles, ...styleProps }}
    >
      {children}
    </Box>
  )
}
